export const urlSearchToObject = (search: string) => {
  const searchParams = new URLSearchParams(search)
  const obj: { [key: string]: string } = {}
  searchParams.forEach((value, key) => {
    obj[key] = value
  })
  return obj
}
